<template>
    <button @click="handleClick" :style="computedButtonStyle">
        <p :style="{ fontSize: textSize + 'px', color: textColor }">
            {{ buttonName }}
        </p>
    </button>
</template>

<script>
import { ref, computed, defineComponent } from "vue";

export default defineComponent({
    props: {
        buttonName: {
            type: String,
            default: "",
        },
        buttonStyle: {},
        textSize: {
            type: Number,
            defalut: 16,
        },
        clicked: {
            type: Boolean,
            default: false,
        },
        textColor: {
            type: String,
            default: "",
        },
        onClick: Function,
    },
    setup(props) {
        const searchQuery = ref("");

        // 클릭 이벤트 핸들러
        const handleClick = () => {
            if (props.onClick) {
                props.onClick(); // 부모 컴포넌트에서 제공한 클릭 이벤트 핸들러 실행
            }
        };

        // 계산된 버튼 스타일
        const computedButtonStyle = computed(() => {
            return {
                ...props.buttonStyle,
                backgroundColor: props.clicked ? "#00A7E7" : "white",
                color: props.clicked ? "white" : "black",
            };
        });

        return {
            searchQuery,
            handleClick,
            computedButtonStyle,
        };
    },
});
</script>

<style scoped>
button {
    padding: 8px 16px;
    border: 0.5px solid black;
    border-radius: 20px;
}
</style>
